import {
  buildModelPresentationV814,
  inferModelProviderV814,
  MODEL_PROVIDER_META_V814,
  matchesModelFiltersV814,
} from './modelPresentationV814';

export const MODEL_BRANDS_V10 = {
  openai: { name: 'OpenAI', icon: 'openai', monochrome: true },
  anthropic: { name: 'Anthropic', icon: 'claude-color' },
  google: { name: 'Google', icon: 'google-color' },
  deepseek: { name: 'DeepSeek', icon: 'deepseek-color' },
  alibaba: { name: 'Alibaba / Qwen', icon: 'qwen-color' },
  zhipu: { name: 'Z.ai', icon: 'zai', monochrome: true },
  xai: { name: 'xAI', icon: 'grok', monochrome: true },
  meta: { name: 'Meta', icon: 'meta-color' },
  rednote: {
    name: 'Xiaohongshu / REDnote',
    icon: 'dotsstudio',
    monochrome: true,
    searchTerms: '小红书 rednote-hilab dots-studio',
  },
  xiaomi: {
    name: 'Xiaomi',
    icon: 'xiaomimimo',
    monochrome: true,
    searchTerms: '小米',
  },
  ant: {
    name: 'Ant Group / inclusionAI',
    icon: 'inclusionai-color',
    format: 'jpg',
    searchTerms: '蚂蚁 inclusion AI',
  },
  mistral: { name: 'Mistral', icon: 'mistral-color' },
  moonshot: { name: 'Moonshot / Kimi', icon: 'moonshot', monochrome: true },
  minimax: { name: 'MiniMax', icon: 'minimax-color' },
  bytedance: { name: 'ByteDance', icon: 'bytedance-color' },
  blackforest: { name: 'Black Forest Labs', icon: 'flux', monochrome: true },
  stability: { name: 'Stability AI', icon: 'stability-color' },
  cohere: { name: 'Cohere', icon: 'cohere-color' },
  microsoft: { name: 'Microsoft', icon: 'microsoft-color' },
  nvidia: { name: 'NVIDIA', icon: 'nvidia-color' },
  amazon: { name: 'Amazon', icon: 'aws-color' },
  kuaishou: {
    name: 'Kuaishou / Kling',
    icon: 'kling-color',
    searchTerms: '快手 可灵',
  },
  shengshu: {
    name: 'ShengShu / Vidu',
    icon: 'vidu-color',
    searchTerms: '生数',
  },
  tencent: {
    name: 'Tencent / Hunyuan',
    icon: 'hunyuan-color',
    searchTerms: '腾讯 混元',
  },
  baidu: {
    name: 'Baidu / ERNIE',
    icon: 'wenxin-color',
    searchTerms: '百度 文心',
  },
  stepfun: { name: 'StepFun', icon: 'stepfun-color', searchTerms: '阶跃星辰' },
  meituan: {
    name: 'Meituan / LongCat',
    icon: 'longcat-color',
    searchTerms: '美团',
  },
  runway: { name: 'Runway', icon: 'runway', monochrome: true },
  luma: { name: 'Luma', icon: 'luma-color' },
  pika: { name: 'Pika', icon: 'pika', monochrome: true },
  ideogram: { name: 'Ideogram', icon: 'ideogram', monochrome: true },
  recraft: { name: 'Recraft', icon: 'recraft', monochrome: true },
  elevenlabs: { name: 'ElevenLabs', icon: 'elevenlabs', monochrome: true },
  suno: { name: 'Suno', icon: 'suno', monochrome: true },
  perplexity: { name: 'Perplexity', icon: 'perplexity-color' },
  jina: { name: 'Jina AI', icon: 'jina', monochrome: true },
  custom: { name: 'Other', icon: null },
};

export const MODEL_SERIES_V10 = {
  gemini: { name: 'Gemini', icon: 'gemini-color' },
  gemma: { name: 'Gemma', icon: 'gemma-color' },
  banana: { name: 'Nano Banana', icon: 'nanobanana-color' },
  dots: { name: 'Dots', icon: 'dotsstudio', monochrome: true },
  mimo: { name: 'Xiaomi MiMo', icon: 'xiaomimimo', monochrome: true },
  ling: {
    name: 'inclusionAI / Ling',
    icon: 'inclusionai-color',
    format: 'jpg',
  },
  ring: {
    name: 'inclusionAI / Ring',
    icon: 'inclusionai-color',
    format: 'jpg',
  },
  ming: {
    name: 'inclusionAI / Ming',
    icon: 'inclusionai-color',
    format: 'jpg',
  },
  muse: { name: 'Meta / Muse', icon: 'meta-color' },
  hailuo: { name: 'Hailuo', icon: 'hailuo-color' },
  sora: { name: 'Sora', icon: 'sora-color' },
  happyhorse: { name: 'HappyHorse', icon: 'happyhorse', monochrome: true },
  seedance: { name: 'ByteDance / Seedance', icon: 'bytedance-color' },
  seedream: { name: 'ByteDance / Seedream', icon: 'bytedance-color' },
  doubao: { name: 'Doubao', icon: 'doubao-color' },
};

const seriesRules = [
  ['bytedance', 'seedance', /(?:^|[^a-z0-9])seedance(?:$|[^a-z])/i],
  ['bytedance', 'seedream', /(?:^|[^a-z0-9])seedream(?:$|[^a-z])/i],
  ['bytedance', 'doubao', /(?:^|[^a-z0-9])doubao(?:$|[^a-z])/i],
  [
    'kuaishou',
    null,
    /(?:^|[^a-z0-9])(?:kling|kwai(?:pilot|kat)?)(?:$|[^a-z])/i,
  ],
  ['shengshu', null, /(?:^|[^a-z0-9])vidu(?:q?\d|$|[^a-z])/i],
  ['minimax', 'hailuo', /(?:^|[^a-z0-9])hailuo(?:$|[^a-z])/i],
  ['openai', 'sora', /(?:^|[^a-z0-9])sora(?:$|[^a-z])/i],
  ['alibaba', 'happyhorse', /(?:^|[^a-z0-9])happy[-_. ]?horse(?:$|[^a-z])/i],
  ['tencent', null, /(?:^|[^a-z0-9])hunyuan(?:$|[^a-z])/i],
  ['baidu', null, /(?:^|[^a-z0-9])(?:ernie|wenxin)(?:$|[^a-z])/i],
  [
    'stepfun',
    null,
    /(?:^|[^a-z0-9])(?:stepfun(?:$|[^a-z])|step[-_. ](?:\d|audio|video|image))/i,
  ],
  ['meituan', null, /(?:^|[^a-z0-9])longcat(?:$|[^a-z])/i],
  ['runway', null, /(?:^|[^a-z0-9])runway(?:ml)?(?:$|[^a-z])/i],
  ['luma', null, /(?:^|[^a-z0-9])(?:luma|ray[-_. ]\d)(?:$|[^a-z])/i],
  ['pika', null, /(?:^|[^a-z0-9])pika(?:$|[^a-z])/i],
  ['ideogram', null, /(?:^|[^a-z0-9])ideogram(?:$|[^a-z])/i],
  ['recraft', null, /(?:^|[^a-z0-9])recraft(?:$|[^a-z])/i],
  [
    'elevenlabs',
    null,
    /(?:^|[^a-z0-9])(?:elevenlabs|eleven[-_](?:multilingual|turbo|flash|v\d))(?:$|[^a-z])/i,
  ],
  ['suno', null, /(?:^|[^a-z0-9])suno(?:$|[^a-z])/i],
  ['perplexity', null, /(?:^|[^a-z0-9])(?:perplexity|sonar)(?:$|[^a-z])/i],
  ['jina', null, /(?:^|[^a-z0-9])jina(?:$|[^a-z])/i],
  [
    'google',
    'gemma',
    /(?:^|[^a-z0-9])(?:codegemma|paligemma|medgemma|shieldgemma|recurrentgemma|t5gemma|embeddinggemma|translategemma|gemma)(?:$|[^a-z])/i,
  ],
  ['google', 'gemini', /(?:^|[^a-z0-9])gemini(?:$|[^a-z])/i],
  ['google', 'banana', /(?:^|[^a-z0-9])nano[-_.\s]*banana(?:$|[^a-z])/i],
  ['rednote', 'dots', /(?:^|[^a-z0-9])dots(?:[-_.\s]*studio)?(?:$|[^a-z])/i],
  ['rednote', 'dots', /(?:^|[^a-z0-9])dot(?:$|[-_.\s]v?\d)/i],
  ['xiaomi', 'mimo', /(?:^|[^a-z0-9])(?:xiaomi[-_.\s]*)?mimo(?:$|[^a-z])/i],
  ['ant', 'ling', /(?:^|[^a-z0-9])ling(?:$|[^a-z])/i],
  ['ant', 'ring', /(?:^|[^a-z0-9])ring(?:$|[^a-z])/i],
  ['ant', 'ming', /(?:^|[^a-z0-9])ming(?:tok)?(?:$|[^a-z])/i],
];

const inferIdentity = (value) => {
  const series = seriesRules.find(([, , expression]) => expression.test(value));
  if (series) return { providerKey: series[0], seriesKey: series[1] };
  // Muse also names unrelated projects. Use Meta's namespace or Muse Spark,
  // never a substring such as "amuse" or a different publisher's Muse model.
  if (/(?:^|[^a-z0-9])muse(?:$|[^a-z])/i.test(value)) {
    if (/(?:^|[^a-z0-9])(?:google|microsoft|nvidia)[/]/i.test(value))
      return { providerKey: inferModelProviderV814({ model_name: value }) };
    if (
      /(?:^|[^a-z0-9])meta(?:[-_.\s]*ai)?[/_-]muse(?:$|[^a-z])/i.test(value) ||
      /(?:^|[^a-z0-9])muse[-_.\s]+spark(?:$|[^a-z])/i.test(value)
    )
      return { providerKey: 'meta', seriesKey: 'muse' };
  }
  if (/(?:^|[^a-z0-9])(?:z[.-]?ai|zhipu|glm)(?:$|[^a-z])/i.test(value))
    return { providerKey: 'zhipu' };
  if (/(?:^|[^a-z0-9])flux(?:$|[^a-z])/i.test(value))
    return { providerKey: 'blackforest' };
  if (/(?:^|[^a-z0-9])(?:chatgpt|o[134])(?:$|[^a-z0-9])/i.test(value))
    return { providerKey: 'openai' };
  const knownProvider = inferModelProviderV814({ model_name: value });
  if (knownProvider !== 'custom') return { providerKey: knownProvider };
  for (const providerKey of [
    'tencent',
    'baidu',
    'meituan',
    'bytedance',
    'stepfun',
  ]) {
    if (
      new RegExp(`(?:^|[^a-z0-9])${providerKey}(?:$|[^a-z0-9])`, 'i').test(
        value
      )
    ) {
      return { providerKey };
    }
  }
  if (/(?:^|[^a-z0-9])seed[-_.]\d/i.test(value))
    return { providerKey: 'bytedance' };
  if (
    /(?:^|[^a-z0-9])(?:rednote(?:[-_.]hilab)?|xiaohongshu)(?:$|[^a-z0-9])/i.test(
      value
    )
  )
    return { providerKey: 'rednote' };
  if (/(?:^|[^a-z0-9])xiaomi(?:$|[^a-z0-9])/i.test(value))
    return { providerKey: 'xiaomi' };
  if (
    /(?:^|[^a-z0-9])(?:inclusion[-_.\s]*ai|ant[-_.\s]*group)(?:$|[^a-z0-9])/i.test(
      value
    )
  )
    return { providerKey: 'ant' };
  if (/(?:^|[^a-z0-9])meta(?:[-_.\s]*(?:llama|ai))?[/]/i.test(value))
    return { providerKey: 'meta' };
  return { providerKey: 'custom' };
};

export const buildModelPresentationV10 = (item) => {
  const presentation = buildModelPresentationV814(item);
  const canonical = inferIdentity(String(item?.model_name || ''));
  // Public model IDs take precedence over an administrator's display label.
  const identity =
    canonical.providerKey !== 'custom'
      ? canonical
      : inferIdentity(String(item?.display_name || ''));
  const { providerKey, seriesKey } = identity;
  const provider = MODEL_BRANDS_V10[providerKey] || MODEL_BRANDS_V10.custom;
  return {
    ...presentation,
    providerKey,
    provider: { ...MODEL_PROVIDER_META_V814[providerKey], ...provider },
    brand: MODEL_SERIES_V10[seriesKey] || provider,
  };
};

const compact = (value) => value.toLowerCase().replace(/[-\s._:/]+/g, '');
export const matchesCatalogSearchV10 = (item, query) => {
  const presentation = item.presentation || buildModelPresentationV10(item);
  const text = `${item.model_name || ''} ${item.display_name || ''} ${
    presentation.provider.name
  } ${presentation.brand.name} ${
    presentation.provider.searchTerms || ''
  }`.toLowerCase();
  return String(query || '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .every(
      (token) =>
        text.includes(token) ||
        (compact(token) !== '' && compact(text).includes(compact(token)))
    );
};

export const matchesCatalogFiltersV10 = (
  item,
  { search = '', category = 'all', group = '', providers = [] } = {}
) =>
  matchesModelFiltersV814(item, category, group) &&
  matchesCatalogSearchV10(item, search) &&
  (providers.length === 0 ||
    providers.includes(
      (item.presentation || buildModelPresentationV10(item)).providerKey
    ));

export const providerFacetsV10 = (items, filters = {}) => {
  const available = new Set();
  const counts = {};
  items.forEach((item) => {
    const key = (item.presentation || buildModelPresentationV10(item))
      .providerKey;
    available.add(key);
    if (matchesCatalogFiltersV10(item, { ...filters, providers: [] }))
      counts[key] = (counts[key] || 0) + 1;
  });
  return Object.entries(MODEL_BRANDS_V10)
    .filter(([key]) => available.has(key))
    .map(([key, brand]) => ({ key, brand, count: counts[key] || 0 }));
};
